<div class="calculations">
    <div *ngIf="employeeTimeOffType" class="main-container">
        <div class="top">
            <div class="title">
                <h3>{{employeeTimeOffType.timeOffType?.name}}</h3>
                <p>{{employeeTimeOffType.timeOffPolicy?.name}}</p>
            </div>
        </div>
        <div class="balance-container">
            <div class="label">
                <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeBalance">
                    {{ 'EmployeeTimeOffTypeBalance' | translate: {Default: "Balance"} }}
                </span>
            </div>
            <div setColor="primaryColour" class="balance">
                <ng-container *ngIf="employeeTimeOffType.availableHours; else noAvailableHours">
                    <span class="balance-value">{{employeeTimeOffType.availableHours | number:'1.2-2' }}</span>
                </ng-container>
                <ng-template #noAvailableHours>
                    <span class="balance-value">0</span>
                </ng-template>
            </div>
            <div class="hours">
                <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeHours">
                    {{ 'Hours' | translate: {Default: "Hours"} }}
                </span>
            </div>
        </div>
    </div>

    <mat-icon *ngIf="employeeTimeOffType" class="material-icons-outlined">arrow_forward_ios</mat-icon>

    <div *ngIf="employeeTimeOffType" class="main-container">
        <div class="top">
            <div class="title">
                <h3>Hours</h3>
                <p>Available after approval</p>
            </div>
        </div>
        <div class="balance-container">
            <div class="label">
                <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeBalance">
                    {{ 'EmployeeTimeOffTypeBalance' | translate: {Default: "Balance"} }}
                </span>
            </div>
            <div setColor="primaryColour" class="balance">
                <span class="balance-value">
                    {{
                    (
                    selectedType === 'BUY'
                    ? employeeTimeOffType.availableHours + hoursInput
                    : employeeTimeOffType.availableHours - hoursInput
                    ) | number:'1.2-2'
                    }}
                </span>
            </div>
            <div class="hours">
                <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeHours">
                    {{ 'Hours' | translate: {Default: "Hours"} }}
                </span>
            </div>
        </div>
        <div class="carry-over-details">
            <div class="row" *ngIf="selectedType && hoursInput">
                <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeCarryOverAmount">
                    {{ selectedType === 'BUY' ? 'Salary Deduction' : 'Salary Addition' }} :
                </span>
                <span>
                    {{ compensation?.payRateCurrency?.id | currencyDisplay: hoursInput * buySellPlanEmployee?.hourlyCost }}
                </span>
            </div>
        </div>
    </div>
</div>